<template>
    <div :class="$style.wrapper">
        <template v-for="chipInfo in filterOptionChipInfos">
            <Chip
                v-if="chipInfo.showChip"
                defaultAction
                :text="chipInfo.text"
                :onClick="() => chipSelected(chipInfo)"
                @remove="() => chipRemoved(chipInfo)"
                :class="$style.chip"
            />
        </template>
    </div>
</template>

<script>
import Chip from '@/components/NewChip/NewChip.vue'
import businessLogic from '@/utils/businessLogic'

export default {
    name: 'JobFilterChipList',
    emits: ['chipSelected', 'chipRemoved', 'countryChipRemoved'],
    components: {
        Chip,
    },
    computed: {
        appliedFilters() {
            return this.$store.state.appliedFilters
        },
        structuredAvailableLocations() {
            return this.$store.getters.structuredAvailableLocations
        },
        selectedAdminAreasInfoByCountry() {
            const infoByCountry = {}

            const ensureFilterIsPresent = (country) => {
                if (!(country in infoByCountry)) {
                    infoByCountry[country] = {
                        country,
                        adminAreaOptions: [],
                    }
                }
            }

            this.appliedFilters
                .find((filter) => filter.name === 'Locations')
                ?.options.forEach((option) => {
                    if (option.type === 'country') {
                        ensureFilterIsPresent(option.name)
                        return
                    }

                    if (option.type !== 'adminArea') {
                        return
                    }

                    ensureFilterIsPresent(option.country)

                    infoByCountry[option.country].adminAreaOptions.push({ ...option })
                })

            Object.values(infoByCountry).forEach((info) => {
                const country = info.country
                info.allAdminAreasChecked =
                    info.adminAreaOptions.length ===
                        Object.keys(this.structuredAvailableLocations[country].adminAreas).length ||
                    !businessLogic.showAdminAreaFiltersUnderCountry(
                        this.structuredAvailableLocations[country].jobCount(),
                    )
            })

            return infoByCountry
        },
        adminAreaVisibilities() {
            const adminAreaVisibilities = {}

            Object.values(this.selectedAdminAreasInfoByCountry).forEach((info) => {
                info.adminAreaOptions.forEach((option) => {
                    adminAreaVisibilities[option.id] = !info.allAdminAreasChecked
                })
            })

            return adminAreaVisibilities
        },
        filterOptionChipInfos() {
            const chipInfos = []

            this.appliedFilters.forEach((filter) => {
                chipInfos.push(...this.generateChipInfosForFilter(filter))
            })

            return chipInfos
        },
    },
    methods: {
        generateChipInfosForFilter(filter) {
            return filter.options.map((option) => {
                const info = {
                    filterName: filter.name,
                    optionId: option.id,
                    text: this.getChipText(filter, option),
                    showChip: true,
                    isCountry: false,
                }

                if (option.type === 'country') {
                    info.showChip =
                        this.selectedAdminAreasInfoByCountry[option.name].allAdminAreasChecked
                    info.adminAreaOptions =
                        this.selectedAdminAreasInfoByCountry[option.name].adminAreaOptions
                    info.isCountry = true
                } else if (option.type === 'adminArea') {
                    info.showChip = this.adminAreaVisibilities[option.id]
                    info.country = option.country
                }

                return info
            })
        },
        getChipText(filter, option) {
            if (filter.name === 'Locations' && option.type !== 'country') {
                return `${option.name}, ${option.country}`
            }
            return option.name
        },
        chipSelected(filterOptionChipInfo) {
            this.$emit('chipSelected', filterOptionChipInfo)
        },
        chipRemoved(filterOptionChipInfo) {
            if (filterOptionChipInfo.isCountry) {
                this.$emit('countryChipRemoved', filterOptionChipInfo)
            } else {
                this.$emit('chipRemoved', filterOptionChipInfo)
            }
        },
    },
}
</script>

<style module src="./JobFilterChipList.css" />
